<template>
  <!-- 单独一张图片情况 -->
  <!-- v-if="imageUrl && showDeleteIcon" -->

  <div class="alone-box">
    <el-image
      v-if="imageUrl"
      :src="imageUrl"
      class="avatar"
    >
    </el-image>
    <div class="image-mask" v-if="imageUrl">
      <div class="image-view-icon" @click.stop="viewImage(imageUrl)"></div>
      <div class="image-delete-icon" v-if="!readonly" @click.stop="deleteUploadHandle(0)"></div>
    </div>
    <div class="progress-box" v-if="isProgress">
      <!-- 上传中··· -->
      <div class="progress-item">
        <div class="loading-spinner"></div>
        <span>上传中</span>
      </div>
    </div>
    <ImageView :imgViewShow="imgViewShow" :imgList="imgViewList" @closeImgView="closeImgView" v-if="imgViewShow"/>
  </div>
</template>
<script>
import ImageView from './ImageView.vue'

export default {
  name: 'AloneBox',
  components: {
    ImageView,
  },
  data() {
    return {
      imgViewShow: false,
      imgViewList: [],
    }
  },
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    isProgress: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },
    viewImage(imageUrl) {
      this.imgViewShow = true
      this.imgViewList = [imageUrl]
    },
    // 关闭图片预览
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.success_upload__tip{
  font-size: 14px;
  color: #86909C;
  margin-top: 104px;
}
.alone-box {
  position: relative;
}
.image-mask {
  position: absolute; /* 绝对定位覆盖容器 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* 半透明黑色蒙层，可自定义颜色 */
  opacity: 0; /* 默认透明（隐藏） */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
  pointer-events: auto; /* 可选：让蒙层不阻挡内容点击（如需点击内容则加） */
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.alone-box:hover .image-mask {
  opacity: 1; /* 完全显示蒙层 */
  .image-view-icon {
    width: 16px;
    height: 16px;
    background: url('../assets/ic-eye@2x.png');
    background-size: cover;
    cursor: pointer;
  }
  .image-delete-icon {
    width: 16px;
    height: 16px;
    background: url('../assets/ic-delete@2x.png');
    background-size: cover;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
